import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CustomerDashboardService } from "../../../services/customer-dashboard.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "src/app/services/common.service";
import { ApiService } from "src/app/services/api.service";
import endpoints from "src/app/helpers/endpoints";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ErrorType } from "src/app/enums/error-type.enum";

@Component({
  selector: "fury-assign-agreement",
  templateUrl: "./assign-agreement.component.html",
  styleUrls: ["./assign-agreement.component.scss"],
})
export class AssignAgreementComponent implements OnInit {
  ngUnsubscribe = new Subject<void>();
  agents = [];
  assignUserForm = new FormGroup({
    assignedUserId: new FormControl("", [Validators.required]),
  });
  constructor(
    public dialogRef: MatDialogRef<AssignAgreementComponent>,
    private customerDashboardService: CustomerDashboardService,
    public commonService: CommonService,
    private apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: { agreementId: string, assignedUser: any },
  ) {}

  ngOnInit(): void {
    this.getAgents();
  }
  close() {
    this.dialogRef.close();
  }
  getAgents() {
    this.customerDashboardService.getAgent$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((agents) => {
        if (agents?.length) {
          this.agents = agents;
          this.assignUserForm.get("assignedUserId").setValue(this.data.assignedUser?.userId || null);
        }
      });
  }
  assignAgreement() {
    this.apiService
      .update(endpoints.customerDashboard.assignAgreement(this.data.agreementId), this.assignUserForm.value)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if(res.body){
            this.apiService.alert(res.body?.message, ErrorType.Success);
            this.dialogRef.close(res.body);
          }
        },
        error: (err: HttpErrorResponse)=>{
          this.apiService.alert(err.message, ErrorType.Error);
        }
      });
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
